import React, { useContext, useState, useRef } from "react";
import ProductContext from "../Context/productContext";

export default function AddVariantModal() {
  const context = useContext(ProductContext);
  const { addProduct } = context;
  const [imageSrc, setImageSrc] = useState({
    image: undefined,
  });
  const [error, setError] = useState("");
  const imageRef = useRef();
  const closeRef = useRef();

  const [product, setProduct] = useState({
    show: false,
    code: "",
    title: "",
    description: "",
    size: "",
    stock: "",
    price: "",
    specialprice: "",
    color: "",
    category: "",
    image: "",
  });

  const changeImageHandler = (e) => {
    setProduct({ ...product, image: e.target.files[0] });

    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setImageSrc({
          image: reader.result,
        });
      }
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  //   Changing Values in textfield
  const onChange = (e) => {
    setProduct({ ...product, [e.target.name]: e.target.value });
  };

  const handleClick = (e) => {
    e.preventDefault();
    if (
      product.code&&
      product.title &&
      product.description&&
      product.size&&
      product.stock&&
      product.price &&
      product.specialprice &&
      product.color &&
      product.category &&
      product.image
    ) {
      addProduct(
        product.show,
        product.code,
        product.title,
        product.description,
        product.size,
 product.stock,
        product.price,
        product.specialprice,
        product.color,
        product.category,
        product.image
      );
      setProduct({
        show: false,
        code:"",
        title: "",
        description:"",
        size:"",
        stock:"",
        price: "",
        specialprice: "",
        color: "",
        category: "",
        image: "",
      });
      setImageSrc({
        image: undefined,
      });
      imageRef.current.value = "";
      setError("");
      closeRef.current.click();
    } else {
      setError("Fill All the Details");
    }
  };

  return (
    <>
      {/* <!-- Modal --> */}
      <div
        className="modal fade"
        id="variantModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Variant
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeRef}
              ></button>
            </div>
            <div className="modal-body">
              <div className="modal-row">
                <div className="col">
                  <form method="POST" encType="multipart/form-data">
                  <p style={{ color: "red" }}>{error}</p>

                    <div className="mb-3">
                      <label htmlFor="code" className="form-label">
                        Product Code
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="code"
                        name="code"
                        value={product.code}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="title" className="form-label">
                        Product Title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="title"
                        name="title"
                        value={product.title}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="description" className="form-label">
                        Description
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="description"
                        name="description"
                        value={product.description}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="size" className="form-label">
                        Size
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="size"
                        name="size"
                        value={product.size}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="stock" className="form-label">
                        Stock
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="stock"
                        name="stock"
                        value={product.stock}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="price" className="form-label">
                        Price
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="price"
                        name="price"
                        value={product.price}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="specialprice" className="form-label">
                        Special Price
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="specialprice"
                        name="specialprice"
                        value={product.specialprice}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="color" className="form-label">
                        Colour
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="color"
                        name="color"
                        value={product.color}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="category" className="form-label">
                        Select Category
                      </label>

                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="category"
                        name="category"
                        value={product.category}
                        onChange={(e) => {
                          setProduct({
                            ...product,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      >
                        <option selected>---</option>
                        <option value="men">Men</option>
                        <option value="women">Women</option>
                      </select>
                    </div>

                    <div className="mb-3">
                      <label for="image" className="form-label">
                        Select Images
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        name="image"
                        id="image"
                        accept="image/*"
                        onChange={(e) => changeImageHandler(e)}
                        ref={imageRef}
                      />
                    </div>
                  </form>
                </div>
                <div className="col">
                  <div className="container">
                    <div className="img-container">
                      {imageSrc.image === undefined ? (
                        <h3 style={{ position: "relative", top: "50%" }}>
                          No Images Selected
                        </h3>
                      ) : (
                        <img
                          src={imageSrc.image}
                          alt=""
                          style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={handleClick}
                // data-bs-dismiss="modal"
                aria-label="Close"
              >
                Upload Product
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
